import { interceptAxios } from '@patsnap-utils/passport';
import { psAxios } from '@patsnap/common-ps-http';
import _ from 'lodash';
import { UserCenterService, SLD, Site } from '@patsnap-utils/biz';
import qs from 'qs';
import { CLIENT_ID, CLIENT_NAME } from '@cores/constants/envConfig';
const clientId = CLIENT_ID;
const clientName = CLIENT_NAME;
export const passportInterceptManager = {
    inject() {
        if (!psAxios.psInterceptors.passportRequestInterceptor) {
            interceptAxios(psAxios);
        }
    },
    eject() {
        psAxios.interceptors.request.eject(psAxios.psInterceptors.passportRequestInterceptor);
        psAxios.interceptors.response.eject(psAxios.psInterceptors.passportResponseInterceptor);
        delete psAxios.psInterceptors.passportRequestInterceptor;
        delete psAxios.psInterceptors.passportResponseInterceptor;
    },
};
export function ejectNodeApiInterceptor() {
    psAxios.interceptors.request.eject(psAxios.psInterceptors.nodeApiInterceptor);
}
/* 简单版本 */
function parse(query = {}) {
    const array = [];
    return Object.keys(query).reduce((array, key) => {
        const value = query[key];
        array.push(`${key}=${value}`);
        return array;
    }, array).join('&');
}
/**
     * 构建登录链接
     * @param appendRedirect 是否需要追加 redirect_uri
     * @param query query 参数
     * @returns 登录链接
     */
export const createLoginHref = function (appendRedirect = true, query = {}) {
    /* 构造 account 地址 */
    const account = new Site({ sld: SLD.WORKSPACE, pathname: 'login/' });
    let _query = qs.parse(window.location.search.replace('?', '')) || {};
    _query = _.omit(_query, ['code', 'spaceId', 'folderId', 'page', 'tab']);
    const params = {
        ..._query,
        ...query,
        client_id: clientId,
        from: clientName,
        redirect_uri: '',
    };
    if (appendRedirect) {
        params.redirect_uri = encodeURIComponent(window.location.href);
    }
    else {
        delete params.redirect_uri;
    }
    const href = `${account.href}?${parse(params)}`;
    console.log('href===========', href);
    return href;
};
export const createLogoutHref = function (appendRedirect = true, query = {}) {
    /* 构造 passport 地址 */
    const { href } = new Site({ sld: SLD.PASSPORT, pathname: 'logout' });
    /* 拼装 account 登录页面 url：参考：https://confluence.zhihuiya.com/pages/viewpage.action?pageId=108873768 */
    const redirect = createLoginHref(appendRedirect, query);
    return `${href}?from=${clientName}&redirect_uri=${encodeURIComponent(redirect)}`;
};
/*
 * 解决浏览器跳转过程中，后续后代码继续执行， 导致跳转路径错误问题 TOC - 38914
 */
export const redirectFn = _.throttle(function (error) {
    const redirectUrl = _.get(error, 'data.redirect_url');
    if (redirectUrl) {
        window.location.href = redirectUrl;
    }
    else if (error && error.errcode) {
        // 被踢出到登录页
        window.location.href = UserCenterService.createLogoutHref(true, { errorCode: error.errcode });
    }
    else {
        // 其他需要登陆的操作
        window.location.href = UserCenterService.createLogoutHref(true, {
            errorCode: 39999,
        });
    }
}, 5000);
export function stoper() {
    if (window.location.search.indexOf('noraven') > -1) {
        throw new Error('Local stop redirect');
    }
}
export const handleExcludesUrlRegExps = ({ config, excludesUrlRegExps, apiVersion }) => {
    if (excludesUrlRegExps === Infinity) {
        return;
    }
    for (const rule of excludesUrlRegExps) {
        const pattern = _.get(rule, 'pattern') || rule;
        const version = _.get(rule, 'version') || apiVersion;
        if (!_.isRegExp(pattern)) {
            console.warn('Error excludes url RegExp: ', rule, config, excludesUrlRegExps, apiVersion);
            continue;
        }
        if (pattern.test(config.url)) {
            /**
             * 如果 API （封装）未指定 header: X-API-Version，才使用 preset 中配置的 version
             */
            if (!('X-API-Version' in config.headers) && version) {
                config.headers['X-API-Version'] = version;
            }
            return config;
        }
    }
};
